//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'InfoPopup',

  data: function () {
    return {
      apiItems: [],
      apiHeader: [],
      apiSearch: "",
      apiLoading: true
    }
  },

  props: {
    item: {
      type: Object,
      require: false,
    },
  },

  computed: {
    isVisibleApiTable: function () {
      return Boolean(['countries', 'services'].includes(this.item.type))
    },
    isVisibleHtmlTable: function () {
      return !Boolean(['countries', 'services'].includes(this.item.type))
    },

    apiItemsFilter: function () {
      if (String(this.apiSearch || '').length < 2) {
        return [...this.apiItems]
      }

      const search = String(this.apiSearch || '').toLowerCase();
      return [...this.apiItems]
        .filter((t) => {
          return Boolean([...(t || '')].find((str) => Boolean(String(str || '').toLowerCase().includes(search))))
        })
    },
  },

  mounted: async function () {
    await this.getApiItems();
  },

  methods: {
    getApiItems: async function () {
      if (!this.isVisibleApiTable) {
        return
      }

      let apiAction = '';
      if (this.item.type === 'services') {
        apiAction = '/service/all';
        this.apiHeader = [this.$t('searchPage.apiHeaders.service.service'), this.$t('searchPage.apiHeaders.service.serviceCode')];
      }
      if (this.item.type === 'countries') {
        apiAction = '/country';
        this.apiHeader = [this.$t('searchPage.apiHeaders.country.country'), this.$t('searchPage.apiHeaders.country.countryCode')];
      }


      const res = await this.$api.agent.transport.get(apiAction).then((res) => {
        return res.data
      }).catch(() => {
        return []
      });

      let apiItems = [];
      if (this.item.type === 'services') {
        res.map((item) => {
          apiItems.push([
            `<img src="${ this.$img.getImage(String(item.icon_id), { width: 64, height: 64 }).url }"/> ${item.name}`,
            item.external_id,
          ])
        });
      }
      if (this.item.type === 'countries') {
        res.map((item) => {
          apiItems.push([
            `<img src="${ this.$img.getImage(String(item.icon_id), { width: 64, height: 64 }).url }"/> ${item.name}`,
            item.external_id,
          ])
        });
      }
      this.apiItems = apiItems;
    },

    closePopup: function () {
      this.$emit('closePopup')
    }
  }
}
